import { useState } from "react";
import { Modal } from "react-bootstrap";
import { getChannelGuideListings } from "services/get-channelGuideListings";
import { useRecoilValue } from "recoil";
import { cartState } from "atoms";

const ChannelGuide = () => {
  const [showTvLisingsModal, setShowTvLisingsModal] = useState(false);
  const [channelGuideData, setChannelGuideData] = useState<any>([]);
  const cart = useRecoilValue(cartState);

  const setChannelGuideClass = (value: string) => {
    if (value === "X") {
      return "channel-guide-value populated";
    } else if (/\d/.test(value)) {
      return "channel-guide-value";
    } else {
      return "channel-guide-value empty";
    }
  };

  const handleChannelListings = async () => {
    const response: any = await getChannelGuideListings(cart.companyName);
    if (response?.ecommerceResponse?._embedded?.channels?.data) {
      setChannelGuideData(response?.ecommerceResponse?._embedded?.channels?.data);
    }
  };
  return (
    <>
      <div className='channel-listing'>
        <button
          className='btn btn-primary btn-sm full-channel-list-link-a-tag'
          onClick={() => {
            handleChannelListings();
            setShowTvLisingsModal(true);
          }}>
          <i className='fa-solid fa-tv me-1' aria-hidden='true'></i>See full channel listing
        </button>
      </div>
      <Modal show={showTvLisingsModal} onHide={() => setShowTvLisingsModal(false)} size='lg' className='channel-listing-modal'>
        <Modal.Header closeButton>
          <Modal.Title>Latest Stream TV Local Lineup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='table-responsive'>
            <table className='table channel-guide-table'>
              <thead>
                <tr>
                  <th>Channel</th>
                  <th>Channel #</th>
                  <th>Replay Hours</th>
                  <th>Basic</th>
                  <th>HD Basic Plus</th>
                  <th>HD Digital Variety</th>
                  <th>Premium</th>
                  <th>Out Of Home</th>
                  <th>WTVE</th>
                </tr>
              </thead>
              <tbody>
                {channelGuideData?.boards ? (
                  channelGuideData.boards.map((item: any) => {
                    return item.items.map((item: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{item.name}</td>
                          {item.column_values.map((value: any, index: number) => {
                            if (value.id !== "subitems") {
                              return (
                                <td key={index} className={setChannelGuideClass(value.text)}>
                                  {value.text}
                                </td>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </tr>
                      );
                    });
                  })
                ) : (
                  <tr>
                    <td>Channel Guide Loading...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ChannelGuide;
